import React, { useEffect } from 'react';
import { ReviewState } from './models';
import { getReviewStateLabel } from '../../services/reviewService';

export interface Reviewer {
    reviewerName: string;
    reviewStatus: string;
    reviewState: string;
    reviewStatusCode:string
}

interface ReviewersDetailsComponentProps {
    reviewers: Reviewer[];
}

const ReviewersDetailsComponent: React.FC<ReviewersDetailsComponentProps> = ({ reviewers }) => {
const [data, setData] = React.useState<Reviewer[]>(reviewers);


const prepareData = (reviewers: Reviewer[]) => {
    let updatedReviewers = [...reviewers];
    const statusCodeMap = new Map<string, Reviewer>();

    reviewers.forEach((reviewer) => {
        if (statusCodeMap.has(reviewer.reviewStatusCode)) {
            const existing = statusCodeMap.get(reviewer.reviewStatusCode)!;
            const namesSet = new Set(existing.reviewerName?.split(',').map(n => n.trim()));
            if (!namesSet.has(reviewer.reviewerName)) {
                existing.reviewerName += `, ${reviewer.reviewerName || ''}`;
            }
        } else {
            statusCodeMap.set(reviewer.reviewStatusCode, { ...reviewer });
        }
    });

    updatedReviewers = Array.from(statusCodeMap.values());
    setData(updatedReviewers);
};
const getCssClassByState=(state:string)=>{
    switch(state.toLowerCase()){
        case ReviewState.COMPLETED.toLowerCase():
            return 'reviewer-info-complete';
        case ReviewState.INPROGRESS.toLowerCase():
            return 'reviewer-info-in-progress';
        case ReviewState.NOTSTART.toLowerCase():
            return 'reviewer-info-not-started';
        default:
            return 'reviewer-info-default';
    }
}
useEffect(() => {
    if (reviewers && reviewers.length > 0) {
        prepareData(reviewers);
    } else {
        setData([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [reviewers]);

    return (
        <div
            style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    flexWrap: 'nowrap',
                    gap: 24,
                    alignItems: 'stretch',
                    maxWidth: '50vw',
                    width: '100%',
                    border: data.length > 0 ? '2px solid #1976d2' : 'none',
                    borderRadius: data.length > 0 ? 12 : 0,
                    padding: data.length > 0 ? 16 : 0,
                    background: data.length > 0 ? '#f9f9f9' : 'transparent',
                    overflowX: 'auto',
                    boxSizing: 'border-box',
                    scrollbarWidth: 'thin',
                    scrollMarginBottom: '10px'
                }}
            >
                {data.map((reviewer, idx) => {
                    const isLast = idx === data.length - 1;
                    return (
                        <React.Fragment key={reviewer.reviewerName + idx}>
                            <div
                                className={getCssClassByState(reviewer.reviewState)}
                            >
                                <div>
                                    <strong>Name(s):</strong> {reviewer.reviewerName}
                                </div>
                                <div>
                                    <strong>Status:</strong> {reviewer.reviewStatus}
                                </div>
                                <div>
                                    <strong>State:</strong> {getReviewStateLabel(reviewer.reviewState)}
                                </div>
                            </div>
                            {/* Show arrow unless it's the last overall */}
                            {!isLast && (
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        alignSelf: 'center',
                                        height: 'auto',
                                    }}
                                >
                                    {/* Arrow SVG */}
                                    <svg
                                        width="40"
                                        height="24"
                                        viewBox="0 0 40 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <line
                                            x1="4"
                                            y1="12"
                                            x2="36"
                                            y2="12"
                                            stroke="#888"
                                            strokeWidth="2"
                                        />
                                        <polygon points="36,6 40,12 36,18" fill="#888" />
                                    </svg>
                                </div>
                            )}
                        </React.Fragment>
                    );
                })}
            </div>
        </div>
    );
};

export default ReviewersDetailsComponent;